export const PROFILE_VIDEO = {
  poster: 'media/profile-setup.jpg',
  playlist: 'profile-setup/HLS/profile-setup.m3u8',
};

export const WORKSPACE_VIDEO = {
  poster: 'media/workspace-setup.jpg',
  playlist: 'workspace-setup/HLS/workspace-setup.m3u8',
};
